import React from 'react';
import { useSceneContext } from '../contexts/SceneContext';

interface ControlButtonsProps {
    animationState: string;
    setAnimationState: (state: string) => void;
}

const ControlButtons: React.FC<ControlButtonsProps> = ({ animationState, setAnimationState }) => {
    const { componentsRef, particlesRef } = useSceneContext();

    // 触发数字化动画
    const handleDigitize = () => {
        if (animationState === 'idle') {
            setAnimationState('digitizing');
            componentsRef.current.forEach(comp => {
                comp.mesh.material = comp.solidMaterial;
                if (comp.solidMaterial) {
                    comp.solidMaterial.transparent = true;
                    comp.solidMaterial.opacity = 1;
                    comp.solidMaterial.needsUpdate = true;
                }
            });
            if (particlesRef.current?.material) {
                particlesRef.current.material.transparent = true;
                particlesRef.current.material.opacity = 0;
                particlesRef.current.material.needsUpdate = true;
            }
        }
    };

    // 触发重置动画
    const handleReset = () => {
        if (animationState === 'idle') {
            setAnimationState('resetting');
            componentsRef.current.forEach(comp => {
                comp.mesh.material = comp.solidMaterial;
                if (comp.solidMaterial) {
                    comp.solidMaterial.transparent = true;
                    comp.solidMaterial.opacity = 0;
                    comp.solidMaterial.needsUpdate = true;
                }
            });
            if (particlesRef.current?.material) {
                particlesRef.current.material.transparent = true;
                particlesRef.current.material.opacity = 1;
                particlesRef.current.material.needsUpdate = true;
            }
        }
    };

    return (
        <div className="flex space-x-4">
            <button
                onClick={handleDigitize}
                className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-md shadow-lg transition-transform transform hover:scale-105 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={animationState !== 'idle'}
            >
                启动数字化
            </button>
            <button
                onClick={handleReset}
                className="px-6 py-3 bg-gray-600 hover:bg-gray-700 text-white font-semibold rounded-md shadow-lg transition-transform transform hover:scale-105 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={animationState !== 'idle'}
            >
                重置状态
            </button>
        </div>
    );
};

export default ControlButtons; 